/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';

/**
 * 
 * @export
 * @interface ChallengePrizeBody
 */
export interface ChallengePrizeBody {
    /**
     * 
     * @type {number}
     * @memberof ChallengePrizeBody
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengePrizeBody
     */
    priority?: number;
    /**
     * 
     * @type {string}
     * @memberof ChallengePrizeBody
     */
    winnerMessage?: string;
    /**
     * Legacy source — exactly one of rewardConfigId | rewardGrant.
     * @type {string}
     * @memberof ChallengePrizeBody
     */
    rewardConfigId?: string;
    /**
     * 
     * @type {RewardGrant}
     * @memberof ChallengePrizeBody
     */
    rewardGrant?: RewardGrant;
    /**
     * Asset IDs for prize bundle carousel images
     * @type {Array<string>}
     * @memberof ChallengePrizeBody
     */
    imageIds?: Array<string>;
}

/**
 * Check if a given object implements the ChallengePrizeBody interface.
 */
export function instanceOfChallengePrizeBody(value: object): value is ChallengePrizeBody {
    return true;
}

export function ChallengePrizeBodyFromJSON(json: any): ChallengePrizeBody {
    return ChallengePrizeBodyFromJSONTyped(json, false);
}

export function ChallengePrizeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengePrizeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'winnerMessage': json['winnerMessage'] == null ? undefined : json['winnerMessage'],
        'rewardConfigId': json['rewardConfigId'] == null ? undefined : json['rewardConfigId'],
        'rewardGrant': json['rewardGrant'] == null ? undefined : RewardGrantFromJSON(json['rewardGrant']),
        'imageIds': json['imageIds'] == null ? undefined : json['imageIds'],
    };
}

export function ChallengePrizeBodyToJSON(json: any): ChallengePrizeBody {
    return ChallengePrizeBodyToJSONTyped(json, false);
}

export function ChallengePrizeBodyToJSONTyped(value?: ChallengePrizeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quantity': value['quantity'],
        'priority': value['priority'],
        'winnerMessage': value['winnerMessage'],
        'rewardConfigId': value['rewardConfigId'],
        'rewardGrant': RewardGrantToJSON(value['rewardGrant']),
        'imageIds': value['imageIds'],
    };
}

